export const languages = ['ru', 'ua', 'en'];

export const translations = {
  ru: {
    nav: { about: 'О нас', advantages: 'Почему мы', contacts: 'Контакты' },
    hero: {
      eyebrow: 'Apps rental service',
      status: 'Слоты на аренду открыты',
      title: 'Забери свой |доллар| назад',
      description: 'Banda Apps — сервис аренды приложений для запуска трафика.',
      cta: 'Написать менеджеру',
      scroll: 'Смотреть дальше',
    },
    pricing: {
      eyebrow: 'Тарифы',
      title: 'Готовые приложения для запуска',
      androidPrice: 'Бесплатно',
      iosPrice: '0.15$',
      priceLabel: 'Стоимость аренды',
      features: ['Оптимизация под регистрацию и депозит', 'Перенос аудитории', 'Пуши под каждое GEO', 'Собственный фарм'],
      cta: 'Начать работу',
    },
    steps: {
      eyebrow: 'Как начать',
      title: 'Старт за 5 минут',
      items: ['Напиши менеджеру', 'Получи доступ к боту', 'Посмотри доступные приложения', 'Выбери подходящее', 'Запусти трафик'],
      cta: 'Связаться с менеджером',
    },
    marquee: 'Banda Apps • Быстрый старт • Любые GEO • Поддержка •',
    comparison: {
      eyebrow: 'Сравнение',
      title: 'Аренда vs разработка',
      rent: 'Аренда',
      dev: 'Разработка',
      rows: [
        ['Запуск', '5–10 минут', '1–3 месяца'],
        ['Бюджет', 'Бесплатно / 0.15$', 'Команда и серверы'],
        ['Гибкость', 'Быстрые готовые решения', 'Полная кастомизация'],
        ['Модерация', 'На стороне сервиса', 'Нужно проходить'],
        ['Обновления', 'Автоматически', 'Своя команда'],
        ['Тестирование', 'Без затрат на разработку', 'Нужен готовый продукт'],
      ],
      note: 'Если работаешь с небольшими объёмами — аренда идеальный вариант. Если льёшь большие объёмы и хочешь эксклюзив — сделаем индивидуальную прилку под тебя.',
    },
    showcase: {
      eyebrow: 'Портфолио',
      title: '|Факты|, а не обещания',
      switchLabel: 'Платформа скриншотов',
      features: ['Долгий срок жизни', 'Регулярные обновления', 'WebView без редиректов', 'Моментальная фиксация событий', 'Локальные пуши', 'Оптимизация конверсии', 'Старт за 5 минут', 'Работа на любых GEO'],
    },
    footer: {
      eyebrow: 'Контакты',
      title: 'Выбор за тобой',
      channel: 'Banda Apps Channel',
      manager: 'Banda Apps Manager',
      instagram: 'Banda Apps Instagram',
      top: 'Наверх',
    },
  },
  ua: {
    nav: { about: 'Про нас', advantages: 'Чому ми', contacts: 'Контакти' },
    hero: {
      eyebrow: 'Apps rental service',
      status: 'Слоти на оренду відкриті',
      title: 'Забери свій |долар| назад',
      description: 'Banda Apps — сервіс оренди застосунків для запуску трафіку.',
      cta: 'Написати менеджеру',
      scroll: 'Дивитися далі',
    },
    pricing: {
      eyebrow: 'Тарифи',
      title: 'Готові застосунки для запуску',
      androidPrice: 'Безкоштовно',
      iosPrice: '0.15$',
      priceLabel: 'Вартість оренди',
      features: ['Оптимізація під реєстрацію та депозит', 'Перенесення аудиторії', 'Пуші під кожне GEO', 'Власний фарм'],
      cta: 'Почати роботу',
    },
    steps: {
      eyebrow: 'Як почати',
      title: 'Старт за 5 хвилин',
      items: ['Напиши менеджеру', 'Отримай доступ до бота', 'Переглянь доступні застосунки', 'Обери потрібне', 'Запусти трафік'],
      cta: 'Зв’язатися з менеджером',
    },
    marquee: 'Banda Apps • Швидкий старт • Будь-які GEO • Підтримка •',
    comparison: {
      eyebrow: 'Порівняння',
      title: 'Оренда vs розробка',
      rent: 'Оренда',
      dev: 'Розробка',
      rows: [
        ['Запуск', '5–10 хвилин', '1–3 місяці'],
        ['Бюджет', 'Безкоштовно / 0.15$', 'Команда та сервери'],
        ['Гнучкість', 'Швидкі готові рішення', 'Повна кастомізація'],
        ['Модерація', 'На стороні сервісу', 'Потрібно проходити'],
        ['Оновлення', 'Автоматично', 'Власна команда'],
        ['Тестування', 'Без витрат на розробку', 'Потрібен готовий продукт'],
      ],
      note: 'Якщо працюєш з невеликими обсягами — оренда ідеальний варіант. Якщо ллєш великі обсяги і хочеш ексклюзив — зробимо індивідуальний застосунок під тебе.',
    },
    showcase: {
      eyebrow: 'Портфоліо',
      title: '|Факти|, а не обіцянки',
      switchLabel: 'Платформа скриншотів',
      features: ['Довгий строк життя', 'Регулярні оновлення', 'WebView без редиректів', 'Миттєва фіксація подій', 'Локальні пуші', 'Оптимізація конверсії', 'Старт за 5 хвилин', 'Робота на будь-яких GEO'],
    },
    footer: {
      eyebrow: 'Контакти',
      title: 'Вибір за тобою',
      channel: 'Banda Apps Channel',
      manager: 'Banda Apps Manager',
      instagram: 'Banda Apps Instagram',
      top: 'Нагору',
    },
  },
  en: {
    nav: { about: 'About', advantages: 'Why us', contacts: 'Contacts' },
    hero: {
      eyebrow: 'Apps rental service',
      status: 'Rental slots open',
      title: 'Get your |dollar| back',
      description: 'Banda Apps is an app rental service built for launching traffic.',
      cta: 'Message the manager',
      scroll: 'Explore',
    },
    pricing: {
      eyebrow: 'Pricing',
      title: 'Ready-to-launch apps',
      androidPrice: 'Free',
      iosPrice: '$0.15',
      priceLabel: 'Rental price',
      features: ['Optimized for registration and deposit', 'Audience transfer', 'Push notifications for every GEO', 'In-house farming'],
      cta: 'Get started',
    },
    steps: {
      eyebrow: 'How to start',
      title: 'Start in 5 minutes',
      items: ['Message the manager', 'Get bot access', 'Browse available apps', 'Choose the right one', 'Launch traffic'],
      cta: 'Contact the manager',
    },
    marquee: 'Banda Apps • Fast launch • Every GEO • Support •',
    comparison: {
      eyebrow: 'Comparison',
      title: 'Rental vs development',
      rent: 'Rental',
      dev: 'Development',
      rows: [
        ['Launch', '5–10 minutes', '1–3 months'],
        ['Budget', 'Free / $0.15', 'Team and servers'],
        ['Flexibility', 'Fast ready-made solutions', 'Full customization'],
        ['Moderation', 'Handled by the service', 'Handled by you'],
        ['Updates', 'Automatic', 'Your own team'],
        ['Testing', 'No development costs', 'A finished product required'],
      ],
      note: 'Working with small volumes — rental is the perfect option. Pushing big volumes and want exclusivity — we\'ll build a custom app just for you.',
    },
    showcase: {
      eyebrow: 'Portfolio',
      title: '|Facts|, not promises',
      switchLabel: 'Screenshot platform',
      features: ['Long app lifetime', 'Regular updates', 'WebView without redirects', 'Instant event tracking', 'Localized push notifications', 'Conversion optimization', 'Launch in 5 minutes', 'Works across every GEO'],
    },
    footer: {
      eyebrow: 'Contacts',
      title: 'The choice is yours',
      channel: 'Banda Apps Channel',
      manager: 'Banda Apps Manager',
      instagram: 'Banda Apps Instagram',
      top: 'Back to top',
    },
  },
};
